import React from "react";

export default React.forwardRef((props, ref) => (
    <button ref={ref} className="btn btn-icon btn-sm btn-outline-primary rounded-circle mx-3">
        <i className={props.icon} ></i>
    </button>
));